<template>
    <b-badge pill class="p-2 px-3 mx-1" variant="success">
        <span>{{ attribute.group.name }}:</span>
        <span> {{ attribute.value }}{{ attribute.group.unit || '' }} </span>
        <span v-if="removable">
            <i
                class="far fa-trash-alt cursor-pointer"
                @click="$emit('remove')"
            />
        </span>
    </b-badge>
</template>

<script>
export default {
    props: {
        attribute: {
            type: Object,
            required: true
        },
        removable: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
